import React, { useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import _ from 'lodash';
import { Tooltip } from 'antd';
import { attributeDate as AttributeDate } from 'theme/icon';
import { DatePickerWithMask } from 'components/UI';
import styles from './styles.scss';

const dateFormat = 'DD.MM.YYYY';
const DateAttribute = props => {
  const { isEditable } = props;
  const [open, setOpen] = useState(false);
  return (
    <div className={styles.row}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <AttributeDate alt="" />
        </div>
        <div className={styles.caption}>
          <Tooltip placement="bottomLeft" title={props.name.length > 25 ? props.name : null}>
            <h4>{_.truncate(props.name, { omission: '...', length: 25 })}</h4>
          </Tooltip>
        </div>
      </div>
      <div className={styles.body}>
        {isEditable ? (
          <DatePickerWithMask
            width="100%"
            open={open}
            onOpenChange={setOpen}
            value={props.value && dayjs(props.value)}
            showToday={false}
            allowClear={false}
            placeholder="Выберите дату"
            onChange={val => {
              props.onChange(dayjs.utc(val));
            }}
          />
        ) : (
          <React.Fragment>{props.value && <span>{dayjs(props.value).format(dateFormat)}</span>}</React.Fragment>
        )}
      </div>
    </div>
  );
};

DateAttribute.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.objectOf(PropTypes.any),
  isEditable: PropTypes.bool.isRequired,
};

DateAttribute.defaultProps = {
  value: null,
};

export default DateAttribute;
